import { render, staticRenderFns } from "./credit-transfer-form.vue?vue&type=template&id=69431208&"
import script from "./credit-transfer-form.vue?vue&type=script&lang=js&"
export * from "./credit-transfer-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports